import React from 'react';
import Const from 'constants';
import {Filter as ClassicFilter} from './game-types/classic';
import {Filter as TiersFilter} from './game-types/tiers';
import {Filter as ShowDownFilter} from './game-types/showdown';
import {Filter as SingleGameFilter} from './game-types/single-game';
import {Filter as LOLClassicFilter} from './sports/lol/classic';
import {Filter as F1ClassicFilter} from './sports/f1/classic';

const Factory = {
    getComponent(sportConfig) {
        if (sportConfig.isSportLol()) {
            return LOLClassicFilter;
        } else if (sportConfig.isSportF1()) {
            return F1ClassicFilter;
        } else if (sportConfig.isSportGolf() && sportConfig.isGameTypeShowDown()) {
            return ClassicFilter;
        }

        if (sportConfig.isGameTypeClassic()) {
            return ClassicFilter;
        } else if (sportConfig.isGameTypeTiers()) {
            return TiersFilter;
        } else if (sportConfig.isGameTypeShowDown()) {
            return ShowDownFilter;
        } else if (sportConfig.isGameTypeSingleGame()) {
            return SingleGameFilter;
        }

        throw new Error(`Factory ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {Factory};
